<template>
  <div style="padding: 0 !important; height: 100% !important">
    <!-- Add language selector at the top-right corner -->
    <div class="language-selector-container white-text">
      <LanguageSelector isLoginFlow />
    </div>
    
    <v-container class="login-container" fluid>
      <v-row style="height: 100% !important">
        <v-col class="pane-padding" cols="5">
          <v-col style="height: 100%; display: flex; flex-direction: column;" lg="10" xl="10">
            <v-img :style="isTDP ? 'height:130px; margin-left:-75px;' : 'height: 130px'" src='@/assets/Logo_Main.svg' max-width="250px" contain />
            <v-form style="margin: auto; width: 100%;" v-model="valid">
              <br />
              <v-text-field :label="$t('form_Login.username.label')" v-model="username" v-on:keyup.enter="submitForm"
                outlined />
              <v-text-field :label="$t('form_Login.password.label')" :type="showPassword ? 'text' : 'password'"
                v-model="password" v-on:keyup.enter="submitForm" outlined >
                <v-icon style="font-size: 16px;" slot="append" class="icon" @click="showPassword = !showPassword">
                  {{ showPassword ? "fa-eye" : "fa-eye-slash" }}
                </v-icon>
              </v-text-field>
              <div class="d-flex align-center justify-end text-end mb-5">
                <router-link to="/reset-password" class="ml-7 my-n5 accent"
                  style="color: var(--v-mediumGray-base) !important;">{{ $t("lostPassword") }}</router-link>
              </div>
              <br />
              <v-row class="justify-space-between">
                <v-btn :loading="loadingLoginAttempt" @click="submitForm">
                  {{ $t("login") }}
                </v-btn>
                <div class="register-link-container">
                  <p class="accent">{{ $t("newToSwiset") }}</p>
                  <router-link :to="registerLink" class="register-link accent">
                    {{ $t("registerLink") }}
                  </router-link>
                </div>
              </v-row>
            </v-form>
          </v-col>
        </v-col>
        <v-col class="login-image d-flex flex-column justify-end" cols="7">
          <div class="align-self-end mb-4 mr-4">
            <img class="mr-4" src="@/assets/UF-AWARDS-swiset.svg" alt="LogoUF" style="width: 150px; height: auto" />
            <img class="mr-4" src="@/assets/Award-Best-Trading-Tools.webp" style="width: 150px; height: auto" />
            <img src="@/assets/Award-Top-100-Global-Startups.webp" style="width: 150px; height: auto" />
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!--Error dialog!-->
    <v-overlay :dark="false" v-model="errorDialog">
      <LoginError :type="errorType" :email="username" :password="password" @close="errorDialog = false" />
    </v-overlay>
  </div>
</template>

<script>
import Quotes from "../quotes";
import { mapMutations } from "vuex";
import Repository from "../../../repositories/auth";
import LoginError from "@/views/Login/components/LoginError";
import LanguageSelector from "@/components/LanguageSelector";

export default {
  name: "Login",
  components: { LoginError, LanguageSelector },
  mounted() {
    this.getQuote();
    this.deleteWhitelabel();
    // Check for inviteCode in URL query params
    if (this.$route.query.inviteCode) {
      this.inviteCode = this.$route.query.inviteCode;
    }
  },
  inject: ["isTDP"],
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.getQuote();
    },
    "$i18n.locale": function () {
      this.getQuote();
    },
  },
  data() {
    return {
      currentQuote: {
        quote:
          "Risk Management is the key for the 99% successful traders. The remaining 1% are just lucky ones",
        by: "Camilo Tobar",
      },
      showPassword: false,
      valid: false,
      username: "",
      password: "",
      usernameRule: [(u) => !!u || this.$t("form_Login.username.rule")],
      passwordRule: [(p) => !!p || this.$t("form_Login.password.rule")],
      loadingLoginAttempt: false,

      // Error
      errorDialog: false,
      errorType: "",

      // Invite code from URL
      inviteCode: null,
    };
  },
  computed: {
    registerLink() {
      // Preserve inviteCode when navigating to register
      if (this.inviteCode) {
        return { path: '/register', query: { inviteCode: this.inviteCode } };
      }
      return '/register';
    }
  },
  methods: {
    getQuote() {
      this.currentQuote =
        this.$i18n.locale === "en"
          ? Quotes.en[(Math.random() * 7).toFixed(0)]
          : Quotes.es[(Math.random() * 7).toFixed(0)];
    },
    ...mapMutations([
      "setToken",
      "setUser",
      "setUserDetails",
      "setPreferredLanguage",
    ]),
    async submitForm() {
      this.loadingLoginAttempt = true;
      if (this.valid) {
        Repository.login(this.username, this.password, this.inviteCode)
          .then(async (response) => {
            if (response.status < 250) {
              this.setToken(`Bearer ${response.data.id_token}`);
              await Repository.getUser().then((response) => {
                this.setUser(response.data);
              });
              await Repository.getLanguage().then((response) => {
                this.setPreferredLanguage(response.data);
              });
              await Repository.getUserDetails().then((response) => {
                this.setUserDetails(response.data);
              });
              await Repository.analyzeNewUserLogin();

              // Show success message if user joined via invite code
              if (this.inviteCode) {
                this.$store.commit('setSnackbar', {
                  show: true,
                  message: this.$t('communityJoinedSuccess', { fallback: 'Welcome! You\'ve successfully joined the community!' }),
                  color: 'success'
                });
              }

              // Check if this is the demo user (ID: 596 or email: demo@swiset.com)
              const user = this.$store.state.user;
              if (user.id === 596 || user.email === 'demo@swiset.com') {
                // Redirect demo user to tournaments (competitions)
                await this.$router.push("/tournaments");
              } else {
                // Regular users go to dashboard
                await this.$router.push("/dashboard");
              }
            }
          })
          .catch((error) => {
            this.loadingLoginAttempt = false;
            this.errorDialog = true;
            if (
              error.response.data.status === 401 &&
              String(error.response.data.detail).endsWith("not activated")
            )
              this.errorType = "NOT_ACTIVATED";
            else if (error.response.data.status === 401)
              this.errorType = "NOT_CREDENTIALS";
            else this.errorType = "UNEXPECTED";
          });
      } else alert(this.$t("alertMessage_Login"));
    },
    signUp() {
      this.$router.push("/register");
    },
    ...mapMutations(["resetWhitelabel"]),
    deleteWhitelabel() {
      this.resetWhitelabel();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../global";

.language-selector-container {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 100;
}

.white-text :deep(.language-selector-trigger) {
  color: white !important;
}

.white-text :deep(.language-name),
.white-text :deep(.dropdown-icon) {
  color: white !important;
}

.v-input__icon--append .v-icon {
  border: none !important;
}

.v-input__icon--append .v-icon:hover {
  border: none !important;
}

.login-container {
  height: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}

.quote {
  color: $text-color;
  font-size: 17px;
}

.by {
  color: $text-color;
  font-size: 15px;
}

.pane-padding {
  padding: 80px 4% 220px 4%;
  height: 100%;
}

.theme--light.v-btn,
.theme--dark.v-btn {
  &.v-btn--has-bg.button-login {
    background-color: var(--v-mainGreen-base);
    border-radius: 3px;
    padding: 5% 7.7% !important;
  }
}

.theme--light.v-btn,
.theme--dark.v-btn {
  &.v-btn--has-bg.button-signup {
    border-radius: 3px;
    padding: 5% 4.2% !important;
  }
}

.login-image {
  padding: 0;
  background-color: #111111;
  background-image: url("https://hub.swiset.com/wp-content/uploads/2024/02/Swiset-Best-AI-Trading-Journal.jpg");
  background-repeat: no-repeat;
  background-size: contain, cover;
  background-position: right;
}

.register-link-container {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--v-mediumGray-base);
}

.register-link {
  color: var(--v-link-base) !important;
  text-decoration: underline;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
}
</style>


